import {TGeolocationResponse} from '../IGeolocation';

/**
 * Represents GeolocationProvider
 */
class GeolocationProvider {
	/**
	 * @constructor
	 */
	constructor() {}

	/**
	 * Returns customer geolocation
	 * @returns {TGeolocationResponse}
	 * @abstract
	 * @public
	 * @memberof GeolocationProvider
	 * @instance
	 */
	public getGeolocation(): Promise<TGeolocationResponse> {
		return Promise.resolve({
			country: '',
			state: '',
			stateName: '',
			continent: ''
		});
	}
}

export default GeolocationProvider;